// extracted by mini-css-extract-plugin
module.exports = {"container":"style-module--container--1vuZB","paragraph":"style-module--paragraph--12HCf","title":"style-module--title--1rj7-","linkContainer":"style-module--linkContainer--1WUxL"};